import { render, staticRenderFns } from "./hero-section-connect.vue?vue&type=template&id=13a66d55&"
import script from "./hero-section-connect.vue?vue&type=script&lang=js&"
export * from "./hero-section-connect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports